import { React, useEffect, useState } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  DownArrowDraw,
  DropDownSearchDraw
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Radio,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { DatePicker } from "antd";
import { DatePickerY, GlobalSet, DisabledStyles } from "../../pageStyled";
import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { useLocation, useNavigate } from "react-router";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import {
  addNewCustomer,
  deleteCustomer,
  editCustomer,
  getCustomerDetails,
  getCustomersForConfiguration,
} from "../../../Services/customerServices";
import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import warning from "../../../Assets/Icons/warning.png";
import { Country, State } from "country-state-city";
import { capital_letter } from "../../../Utils/helper/helper";
import styled from "styled-components";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";

const PhoneDetails = styled.div`
.ant-input-affix-wrapper {
  border : none !important;
}
`;

const { Option } = Select;
const provinceData = ["India", "USA"];

const userTypeData = [
  { label: "Dealer", value: "dealer" },
  { label: "Direct Customer", value: "direct_customer" },
];

const userStatusData = [
  { label: "Active", value: "active" },
  { label: "Disabled", value: "disabled" },
];
const customerTypeData = [
  { label: "Domestic", value: "domestic" },
  { label: "Export", value: "export" },
];

const diameterData = [
  { label: "Single", value: "single" },
  { label: "Multiple", value: "multiple" },
];

const cityData = {
  India: ["Arunachal Pradesh", "Andra Pradesh", "Bihar", "Chhattisgarh"],
  USA: ["Arizona", "California", "Colorado"],
};
const { TextArea } = Input;

const AddNewCustomer = (props) => {
  const [cities, setCities] = useState([]);
  const [deliveryCities, setDeliveryCities] = useState([]);
  const [userStatus, setUserStatus] = useState(userStatusData[0].value);
  const [category, setCategory] = useState(customerTypeData[0].value);
  const [reelDiameter, setReelDiameter] = useState(diameterData[0].value);
  const [checkedBox, setCheckedBox] = useState(false);
  const [visible, setVisible] = useState(false);
  const [viewDelete, setViewDelete] = useState(false);
  const [customerDetails, setCustomerDetails] = useState();
  const [actionResponse, setActionResponse] = useState({});
  // const [addToaster, setAddToaster] = useState(false);
  const [editToaster, setEditToaster] = useState(false);
  const [aliasList, setAliasList] = useState();
  const [isOfficeCountryDropdownOpen, setOfficeCountryDropdown] = useState(false);
  const [isOfficeStateDropdownOpen, setOfficeStateDropdown] = useState(false);
  const [isDeliveryCountryDropdownOpen, setDeliveryCountryDropdown] = useState(false);
  const [isDeliveryStateDropdownOpen, setDeliveryStateDropdown] = useState(false);
  // const [primaryContactvalue, setPrimaryContactvalue] = useState();
  const [primaryContactError, setPrimaryContactError] = useState("");
  const location = useLocation();
  const action = location.state.action;
  const customerCode = location.state.customercode;
  const roles = location.state.roles;
  const history = useNavigate();
  const [deleteError, setDeleteError] = useState(false);
  const [deleteMsg, setDeleteMsg] = useState("");
  const [customersList , setCustomersList] = useState([]);
  const [switchFetchOrdersfromERP,setSwitchFetchOrdersfromERP] = useState(false);

  useEffect(()=>{
    (async()=>{
      const orderManagementSettings = await getWorkflowSettings("order_management");
      setSwitchFetchOrdersfromERP(orderManagementSettings?.data?.fetch_orders_from_erp?.value);
    })();
  },[])
  // console.log("location", location, action, customerCode);
  const [form] = Form.useForm();

  const routeBack = (action, response) => {
    history("../customer-records/", {
      state: { action: action, response: response },
    });
  };
  const OnOfficeCountryToggleSelect =()=>{
    setOfficeCountryDropdown((prevState) => !prevState
  )
  }
  const OnOfficeStateToggleSelect =()=>{
    setOfficeStateDropdown((prevState) => !prevState
  )
  }
  const OnDeliveryCountryToggleSelect =()=>{
    setDeliveryCountryDropdown((prevState) => !prevState
  )
  }
  const OnDeliveryStateToggleSelect =()=>{
    setDeliveryStateDropdown((prevState) => !prevState
  )
  }
  const modalShow = () => {
    setVisible(true);
  };

  const modalCancel = () => {
    setVisible(false);
  };

  const modalConfirm = () => {
    setVisible(false);
    routeBack();
  };

  const modalShowDelete = () => {
    setViewDelete(true);
  };

  const modalCancelDelete = () => {
    setViewDelete(false);
  };

  const modalConfirmDelete = (code) => {
    deleteCustomerRecord(code);
    setViewDelete(false);
  };

  // const showAddToaster = () => {
  //   setAddToaster(true);
  //   setTimeout(() => setAddToaster(false), 3000);
  // };

  const showEditToaster = () => {
    setEditToaster(true);
    setTimeout(() => setEditToaster(false), 3000);
    setTimeout(() => history("../customer-records/"), 3700);
  };

  const onChangeHandlerBox = (e) => {
    setCheckedBox(e.target.checked);
    !checkedBox &&
      form.setFieldsValue({
        delivery_address_line_1: form.getFieldValue("address_line_1"),
        delivery_address_line_2: form.getFieldValue("address_line_2"),
        delivery_state: form.getFieldValue("state"),
        delivery_city: form.getFieldValue("city"),
        delivery_pincode: form.getFieldValue("pincode"),
        delivery_country: form.getFieldValue("country"),
      });
  };

  const addCustomer = (body) => {
    addNewCustomer(body).then((response) => {
      const res = {
        error: response.error,
        data: response.data,
        msg: response.msg,
      };
      // setActionResponse(res);
      routeBack("add", res);
      // showAddToaster();
    });
  };

  const editCustomerDetails = (code, body) => {
    editCustomer(code, body).then((response) => {
      const res = {
        error: response.error,
        code: response.data.code,
        msg: response.msg,
      };
      setActionResponse(res);
      showEditToaster();
    }).catch((error) => {
      console.log(error);
      if(error?.response?.status == 500){
        const res = {
          error: true,
          code: code,
          msg: "Something went wrong. Please try again",
        };
        setActionResponse(res);
      } else{
        const res = {
          error: true,
          code: code,
          msg: error?.response?.data?.msg,
        };
        setActionResponse(res);      
      }
      showEditToaster();
    });
  };

  const deleteCustomerRecord = (code) => {
    deleteCustomer(code).then((response) => {
      const res = {
        error: response.error,
        code: code,
        msg: response.msg,
      };
      // setActionResponse(res);
      routeBack("delete", res);
    }).catch((error) => {
    //   setDeleteError(true);
    // setTimeout(() => {
    //   setDeleteError(false);
    // }, 3000);
    //   console.log(error);
      console.log(error);
      setDeleteError(true);
      if(error?.response?.status == 500){
          setDeleteMsg("Something went wrong. Please try again");
      } else{
          setDeleteMsg("This customer cannot be deleted as it has orders associated with it. You can disable it for further use.");
      }
      setTimeout(() => {
       setDeleteError(false);
      }, 3000);
    });;
  };

  const handleStatusChange = (e) => {
    setUserStatus(e.target.value);
  };

  const handleDiameterChange = (e) => {
    setReelDiameter(e.target.value);
  };

  const handleProvinceChange = (value) => {
    console.log("country", value);
    setCities(State.getStatesOfCountry(value));
    form.setFieldsValue({ state: State.getStatesOfCountry(value)[0]?.name });
  };

  const handleDeliveryProvinceChange = (value) => {
    setDeliveryCities(State.getStatesOfCountry(value));
    form.setFieldsValue({
      delivery_state: State.getStatesOfCountry(value)[0]?.name,
    });
  };

  const getFlag = (short) => {
    const data = require(`world_countries_lists/data/flags/24x24/${short.toLowerCase()}.png`);
    // for dumi
    if (typeof data === "string") {
      return data;
    }
    // for CRA
    return data.default;
  };

  const handleSubmit = () => {
    !switchFetchOrdersfromERP && validatePrimaryContact(form.getFieldValue("primary_phone_number"));
    form.submit();
  };

  const handleEdit = () => {
    history("../customer-records/edit-customer", {
      state: { action: "edit", customercode: customerCode },
    });
  };

  const validatePrimaryContact = (e) => {
    if (!e.phone) setPrimaryContactError("This field is required");
    else if (!/^\d+$/.test(e.phone))
      setPrimaryContactError("Only numerical values are accepted");
    else setPrimaryContactError("");
  };

  const onFinish = (e) => {
    let customerName = capital_letter(e.name.trim());
    const body = {
      address_line_1: e.address_line_1,
      address_line_2: e.address_line_2,
      state: e.state,
      city: e.city?capital_letter(e.city):e.city,
      pincode: e.pincode,
      country: Country.getCountryByCode(e.country)?.name,
      delivery_address_line_1: e.delivery_address_line_1,
      delivery_address_line_2: e.delivery_address_line_2,
      delivery_state: e.delivery_state,
      delivery_city: e.city?capital_letter(e.delivery_city):e.city,
      delivery_pincode: e.delivery_pincode,
      delivery_country: Country.getCountryByCode(e.delivery_country)?.name,
      primary_phone_number: e.primary_phone_number?.phone,
      secondary_phone_number: e?.secondary_phone_number?.phone,
      primary_email: e.primary_email,
      secondary_email: e.secondary_email,
      code: e.code,
      // name: e.name.charAt(0).toUpperCase() + e.name.slice(1),
      name: customerName,
      alias: e.alias.toUpperCase(),
      type: e.type,
      person_of_contact: e.person_of_contact,
      gst_number: e.gst_number,
      pan_number: e.pan_number,
      same_as_office_address: checkedBox,
      // dealership_date: e.dealership_date,
      ...(e.dealership_date && {
        dealership_date: moment(e.dealership_date).format("YYYY-MM-DD"),
      }),
      reel_diameter: e.diameter,
      status: e.status,
      remarks: e.remarks,
      category: e.category
    };
    console.log("Submission", body);
    if (switchFetchOrdersfromERP || !primaryContactError) {
      if (action === "add") addCustomer(body);
      else if (action === "edit") editCustomerDetails(customerCode, body);
    }
    // : null;
  };

  useEffect(() => {
    getCustomersForConfiguration().then((response) => {
      const list = response.map((customer) => customer.alias);
      const customers = response.map((customer) => customer.name);
      setCustomersList(customers);
      setAliasList(list);
    });
  }, []);

  useEffect(() => {
    // form.resetFields();
    customerCode &&
      getCustomerDetails(customerCode)
        .then((response) => {
          setCustomerDetails(response.data);
          setCheckedBox(response.data?.same_as_office_address)
          setCities(State.getStatesOfCountry(Country.getAllCountries().filter(country => country.name == response.data?.country)[0]?.isoCode));
          setDeliveryCities(State.getStatesOfCountry(Country.getAllCountries().filter(country => country.name == response.data?.delivery_country)[0]?.isoCode));
          // setCities(State.getStatesOfCountry("India"));
        })
        .catch((error) => console.log(error));
    return () => {
      // form.resetFields();
      // setCustomerDetails({});
    };
  }, [customerCode]);

  // useEffect(() => {
  //   console.log(form.getFieldValue("primary_phone_number"));
  // }, [form.getFieldValue("primary_phone_number")]);
const onViewChangeHistory = () => {
  history("../history", {
    state: {
      customer: {
      action: action,
      route: "../customer-records/view-customer",
      customercode: customerCode,
      roles: roles},
      logType: "Customer",
      name: customerDetails.name,
      searchText : "Search change in customer property"
    },
  });
}
const onEditChangeHistory = () => {
  history("../history", {
    state: {
      customer: {
      action: action,
      route:  "../customer-records/edit-customer",
      customercode: customerCode,
      roles: roles},
      logType: "Customer",
      name: customerDetails.name,
      searchText : "Search change in customer property"
    },
  });
}
  return (action === "add" || customerDetails) && aliasList ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={action === "view" && routeBack}
          title={action == "add" ? "Add a new customer" : customerDetails?.name}
          extra={
            action === "add"
              ? [
                  <Button key="1" className="textTypeBtn" onClick={modalShow}>
                    Cancel changes
                  </Button>,
                  <Button key="2" className="themeBtn" onClick={handleSubmit}>
                    <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                    Add Customer
                  </Button>,
                ]
              : action === "edit"
              ? [
                  <Button key="1" className="textTypeBtn" onClick={modalShow}>
                    Cancel changes
                  </Button>,
                  <Button key="3" className="themeBtn" onClick={handleSubmit}>
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Save Customer
                  </Button>,
                ]
              : [
                <Button
                key="1"
                className="themeBtn noBg"
                onClick={onViewChangeHistory}
              >
                <Iconmoon icon="order-entry-icon" size={14} color="#EA655B" />
                View Change History
              </Button>,
                  <Button
                    key="8"
                    className="themeBtn noBg"
                    onClick={modalShowDelete}
                    disabled={!roles.edit}
                  >
                    <Iconmoon icon="delete" size={14} color="#EA655B" />
                    Delete Customer
                  </Button>,
                  <Button
                    key="5"
                    className="themeBtn"
                    onClick={handleEdit}
                    disabled={!roles.edit}
                  >
                    <Iconmoon icon="edit" size={14} color="#ffffff" />
                    Edit Customer
                  </Button>,
                ]
          }
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              onFinish={onFinish}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      The general details will be used in order records and
                      reports
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  {action !== "add" && (
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Customer Code</label>
                          <p>This is an auto generated code</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div className="boxFormType">
                          <Form.Item
                            name="code"
                            // rules={[{ required: true }]}
                            initialValue={customerDetails?.code}
                            className=""
                          >
                            <Input disabled />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Customer Name</label>
                        <p>The customer will be identified by this name</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="name"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            // {
                            //   max: 50,
                            //   message:
                            //     "Name can have a maximum of 50 characters",
                            // },
                            {
                              validator(_, value) {
                                if (customerDetails) {
                                  if (value === customerDetails.name)
                                    return Promise.resolve();
                                }
                                if (
                                  value == null ||
                                  !customersList.filter((data) => data.toUpperCase() === value.toUpperCase()).length
                                ) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(
                                    "This name exists for another customer"
                                  );
                                }
                              },
                            },
                          ]}
                          initialValue={
                            action === "add" ? "" : customerDetails.name
                          }
                          className=""
                        >
                          <Input
                            placeholder={
                              action === "view"
                                ? ""
                                : "Enter name of the customer"
                            }
                            style={{ textTransform: "capitalize" }}
                            disabled={action === "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Customer Alias</label>
                        <p>
                          An alternate short name used to identify this customer
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        {/* {console.log("alias", aliasList)} */}
                        <Form.Item
                          name="alias"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              max: 20,
                              message:
                                "Alias can have a maximum of 20 characters",
                            },
                            {
                              validator(_, value) {
                                if (customerDetails) {
                                  if (value === customerDetails.alias)
                                    return Promise.resolve();
                                }
                                if (
                                  value == null ||
                                  !aliasList.filter((data) => data.toUpperCase() === value.toUpperCase()).length
                                ) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(
                                    "This alias exists for another customer"
                                  );
                                }
                              },
                            },
                          ]}
                          initialValue={
                            action == "add" ? "" : customerDetails?.alias
                          }
                          className=""
                        >
                          <Input
                            placeholder={
                              action === "view"
                                ? ""
                                : "Enter alias of the customer"
                            }
                            style={{ textTransform: "uppercase" }}
                            disabled={action == "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Type of Customer</label>
                        <p>Customer can be a dealer or a direct customer </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="type"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                          ]}
                          className=""
                          initialValue={
                            action == "add" ? null : customerDetails?.type
                          }
                        >
                          <Select
                            placeholder={action === "view" ? "" : "Select"}
                            suffixIcon={<DownArrowDraw />}
                            // defaultValue={userTypeData[0]}
                            disabled={action == "view"}
                          >
                            {userTypeData.map((type) => (
                              <Option key={type.value}>
                                {type.label}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          GST Number <span>(Optional)</span>
                        </label>
                        <p>GST identification number of customer (GSTIN)</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="gst_number"
                          rules={[
                            {
                              pattern: /^[0-9a-zA-Z]+$/,
                              message: "GST Number is invalid",
                            },
                            {
                              len: 15,
                              message: "GST Number is invalid",
                            },
                          ]}
                          initialValue={
                            action == "add" ? "" : customerDetails?.gst_number
                          }
                          className=""
                        >
                          <Input
                            placeholder={
                              action === "view" ? "" : "Enter GST Number"
                            }
                            disabled={action == "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          PAN Number<span>(Optional)</span>
                        </label>
                        <p>10 Digit PAN number of the customer</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="pan_number"
                          rules={[
                            {
                              pattern: /^[0-9a-zA-Z]+$/,
                              message: "PAN Number is invalid",
                            },
                            {
                              len: 10,
                              message: "PAN Number is invalid",
                            },
                          ]}
                          initialValue={
                            action == "add" ? "" : customerDetails?.pan_number
                          }
                          className=""
                        >
                          <Input
                            placeholder={action === "view"?'':"Enter PAN Number"}
                            disabled={action == "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Date of Dealership <span>(Optional)</span>
                        </label>
                        <p>
                          The date on which dealership certificate was issued
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <DatePickerY>
                          <Form.Item
                            name="dealership_date"
                            initialValue={
                              action == "add"
                                ? ""
                                : customerDetails.dealership_date
                                ? moment(
                                    customerDetails.dealership_date,
                                    "YYYY-MM-DD"
                                  )
                                : ""
                            }
                          >
                            <DatePicker
                              format={"DD/MM/YYYY"}
                              disabled={action == "view"}
                            />
                          </Form.Item>
                        </DatePickerY>
                      </div>
                    </Col>
                  </Row>
                  
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Customer Category <span>(Optional)</span></label>
                        <p>
                          The customer can be domestic or export
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{
                          justifyContent: "flex-end",
                          display: "flex",
                        }}
                      >
                        <Form.Item
                          name="category"
                          initialValue={
                            action == "add" ? "" : customerDetails.category
                          }
                          className=""
                        >
                          <Radio.Group
                            options={customerTypeData}
                            optionType="button"
                            buttonStyle="solid"
                            disabled={action == "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Contact Details</h2>
                    <p>
                      The contact details will be used to contact this customer
                      for support and automatic emails
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Contact Person</label>
                        <p>Mill can contact this person for support</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="person_of_contact"
                          rules={[
                            {
                              required: !switchFetchOrdersfromERP,
                              message: "This field is required",
                            },
                            {
                              max: 50,
                              message:
                                "Name can have a maximum of 50 characters",
                            },
                          ]}
                          initialValue={
                            action == "add"
                              ? ""
                              : customerDetails?.person_of_contact
                          }
                          className=""
                        >
                          <Input
                            placeholder={action === "view"?'':"Enter the name of the contact person"}
                            style={{ textTransform: "capitalize" }}
                            disabled={action === "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Primary Contact Number</label>
                        <p>
                          Mill can use this number as primary contact number
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                      <PhoneDetails>
                        <ConfigProvider
                          locale={en}
                          areaMapper={(area) => {
                            return {
                              ...area,
                              emoji: (
                                <img
                                  alt="flag"
                                  style={{
                                    width: 18,
                                    height: 18,
                                    verticalAlign: "sub",
                                  }}
                                  src={getFlag(area.short)}
                                />
                              ),
                            };
                          }}
                        >
                          <Form.Item
                            name="primary_phone_number"
                            rules={[
                              {
                                required: !switchFetchOrdersfromERP,
                                message: "This field is required",
                              },
                            ]}
                            className=""
                            initialValue={{
                              short: "IN",
                              phone:
                                action == "add"
                                  ? ""
                                  : customerDetails?.primary_phone_number,
                            }}
                          >
                            <CountryPhoneInput
                              className={`intlPhone ${
                                primaryContactError ? "showErrorBorder" : ""
                              }`}
                              placeholder={action === "view"?'':"Enter the contact number"}
                              disabled={action == "view"}
                              onChange={validatePrimaryContact}
                            />
                          </Form.Item>
                          {primaryContactError ? (
                            <span
                              className="errorText"
                              style={{ color: "#ea4e2c" }}
                            >
                              {primaryContactError}
                            </span>
                          ) : null}
                        </ConfigProvider>
                        </PhoneDetails>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Alternate Contact Number<span> (Optional)</span>
                        </label>
                        <p>
                          Mill can use this number as alternate contact number
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                      <PhoneDetails>
                        <ConfigProvider
                        style = {{border: 'none'}}
                          locale={en}
                          areaMapper={(area) => {
                            return {
                              ...area,
                              emoji: (
                                <img
                                  alt="flag"
                                  style={{
                                    width: 18,
                                    height: 18,
                                    verticalAlign: "sub",
                                  }}
                                  src={getFlag(area.short)}
                                />
                              ),
                            };
                          }}
                        >
                          <Form.Item
                            name="secondary_phone_number"
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                            className=""
                            initialValue={{
                              short: "IN",
                              phone:
                                action == "add"
                                  ? ""
                                  : customerDetails?.secondary_phone_number,
                            }}
                          >
                            <CountryPhoneInput
                              className="intlPhone"
                              placeholder={action === "view"?'':"Enter the alternate contact number"}
                              disabled={action == "view"}
                            />
                          </Form.Item>
                        </ConfigProvider>
                        </PhoneDetails>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Primary Email ID</label>
                        <p>
                          Mill can use this email as primary mode of contact
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="primary_email"
                          rules={[
                            {
                              required: !switchFetchOrdersfromERP,
                              message: "This field is required",
                            },
                            {
                              type: "email",
                              message: "Email Format is invalid",
                            },
                          ]}
                          initialValue={
                            action == "add"
                              ? ""
                              : customerDetails?.primary_email
                          }
                          className=""
                        >
                          <Input
                            placeholder={action === "view"?'':"Enter the email id"}
                            disabled={action == "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Secondary Email ID<span> (Optional)</span>
                        </label>
                        <p>
                          Mill can use this email as alternate mode of contact
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="secondary_email"
                          rules={[
                            {
                              type: "email",
                              message: "Email Format is invalid",
                            },
                          ]}
                          initialValue={
                            action == "add"
                              ? ""
                              : customerDetails?.secondary_email
                          }
                          className=""
                        >
                          <Input
                            placeholder={action === "view"?'':"Enter the alternate email id"}
                            disabled={action == "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Office Address</h2>
                    <p>The address of the customer's office</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Complete Office Address</label>
                        <p>
                          The complete postal office address of the customer
                        </p>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <DisabledStyles>
                          <Form.Item
                            name="address_line_1"
                            rules={[
                              {
                                required: !switchFetchOrdersfromERP,
                                message: "This field is required",
                              },
                              {
                                max: 50,
                                message: "Maximum 50 characters are allowed",
                              },
                            ]}
                            initialValue={
                              action == "add"
                                ? ""
                                : customerDetails?.address_line_1
                            }
                            className=""
                          >
                            <Input
                              className="disabled-check"
                              placeholder={action === "view"?'':"First Line of address"}
                              disabled={action == "view"}
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <div className="boxFormType">
                        <DisabledStyles>
                          <Form.Item
                            name="address_line_2"
                            rules={[
                              {
                                max: 50,
                                message: "Maximum 50 characters are allowed",
                              },
                            ]}
                            initialValue={
                              action == "add"
                                ? ""
                                : customerDetails?.address_line_2
                            }
                            className=""
                          >
                            <Input
                              className="disabled-check"
                              placeholder={action === "view"?'':"Second Line of address"}
                              disabled={action == "view"}
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <Col span={12} className="d-flex">
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="country"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? null
                                  : Country.getAllCountries().filter(country => country.name == customerDetails?.country)[0]?.isoCode
                                  // : customerDetails?.country
                              }
                              className=""
                            >
                              <Select
                                className="disabled-check"
                           suffixIcon={ isOfficeCountryDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                          onBlur = {OnOfficeCountryToggleSelect}
                          onFocus = {OnOfficeCountryToggleSelect}
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, option) => 
                            option.children.toLowerCase().
                            includes(input.toLowerCase())}
                                onChange={handleProvinceChange}
                                placeholder={action === "view"?'':"Country"}
                                disabled={action == "view"}
                              >
                                {Country.getAllCountries().map((province) => (
                                  <Option key={province.isoCode}>
                                    {province.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="state"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={
                                action == "add" ? null : customerDetails?.state
                              }
                              className=""
                            >
                              <Select
                                suffixIcon={ isOfficeStateDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                                onBlur = {OnOfficeStateToggleSelect}
                                onFocus = {OnOfficeStateToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => 
                                  option.children.toLowerCase().
                                  includes(input.toLowerCase())}
                                placeholder={action === "view"?'':"State"}
                                disabled={action == "view"}
                              >
                                {cities.map((city) => (
                                  <Option key={city.name}>{city.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                      <Col span={12} className="d-flex">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <DisabledStyles>
                            <Form.Item
                              name="city"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                                {
                                  max: 50,
                                  message: "Maximum 50 characters are allowed",
                                },
                              ]}
                              initialValue={
                                action == "add" ? "" : customerDetails?.city
                              }
                              className=""
                            >
                              <Input
                                placeholder={action === "view"?'':"City"}
                                className="disabled-check"
                                style={{ textTransform: "capitalize" }}
                                disabled={action == "view"}
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="pincode"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                                { min: 6, message: "Minimum length: 6" },
                                { max: 6, message: "Maximum length: 6" },
                                {
                                  pattern: new RegExp(/^[0-9]+$/),
                                  message: "Only Numeric value is possible",
                                },
                              ]}
                              initialValue={
                                action == "add" ? "" : customerDetails?.pincode
                              }
                              className=""
                            >
                              <Input
                                className="disabled-check"
                                placeholder={action === "view"?'':"ZIP code"}
                                disabled={action == "view"}
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Delivery Address</h2>
                    <p>
                      The order of this customer will be delivered at this
                      address
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Building Number and Street Address</label>
                        <p>
                          The complete postal address of the customer to which
                          orders can be delivered
                        </p>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <GlobalSet>
                          {console.log(checkedBox)}
                          <Form.Item
                            name="Contactaddress"
                            rules={[]}
                            className=""
                          >
                            <div className="checklist-address">
                              <Checkbox
                                type="checkbox"
                                defaultChecked={
                                  customerDetails?.same_as_office_address
                                }
                                value={checkedBox}
                                onChange={onChangeHandlerBox}
                                disabled={action == "view"}
                              />
                              <p>Delivery address is same as office address</p>
                            </div>
                          </Form.Item>
                        </GlobalSet>

                        <DisabledStyles>
                          <Form.Item
                            name="delivery_address_line_1"
                            rules={[
                              {
                                required: !switchFetchOrdersfromERP,
                                message: "This field is required",
                              },
                              {
                                max: 50,
                                message: "Maximum 50 characters are allowed",
                              },
                            ]}
                            initialValue={
                              action == "add"
                                ? ""
                                : customerDetails?.delivery_address_line_1
                            }
                            className=""
                          >
                            <Input
                              disabled={checkedBox || action == "view"}
                              className="disabled-check"
                              placeholder={action === "view"?'':"First Line of address"}
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <div className="boxFormType">
                        <DisabledStyles>
                          <Form.Item
                            name="delivery_address_line_2"
                            rules={[
                              {
                                max: 50,
                                message: "Maximum 50 characters are allowed",
                              },
                            ]}
                            initialValue={
                              action == "add"
                                ? ""
                                : customerDetails?.delivery_address_line_2
                            }
                            className=""
                          >
                            <Input
                              disabled={checkedBox || action == "view"}
                              className="disabled-check"
                              placeholder={action === "view"?'':"Second Line of address"}
                            />
                          </Form.Item>
                        </DisabledStyles>
                      </div>

                      <Col span={12} className="d-flex">
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="delivery_country"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? null
                                  : Country.getAllCountries().filter(country => country.name == customerDetails?.delivery_country)[0]?.isoCode
                                  // : customerDetails?.delivery_country
                              }
                              className=""
                            >
                              <Select
                                className="disabled-check"
                                disabled={checkedBox || action == "view"}
                                suffixIcon={ isDeliveryCountryDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                                onBlur = {OnDeliveryCountryToggleSelect}
                                onFocus = {OnDeliveryCountryToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => 
                                  option.children.toLowerCase().
                                  includes(input.toLowerCase())}
                                // defaultValue={provinceData[0]}
                                onChange={handleDeliveryProvinceChange}
                                placeholder={action === "view"?'':"Country"}
                              >
                                {Country.getAllCountries().map((province) => (
                                  <Option key={province.isoCode}>
                                    {province.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="delivery_state"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? null
                                  : customerDetails?.delivery_state
                              }
                              className=""
                            >
                              <Select
                                disabled={checkedBox || action == "view"}
                                suffixIcon={ isDeliveryStateDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                                onBlur = {OnDeliveryStateToggleSelect}
                                onFocus = {OnDeliveryStateToggleSelect}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) => 
                                  option.children.toLowerCase().
                                  includes(input.toLowerCase())}
                                placeholder={action === "view"?'':"State"}
                              >
                                {deliveryCities.map((city) => (
                                  <Option key={city.name}>{city.name}</Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                      <Col span={12} className="d-flex">
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <DisabledStyles>
                            <Form.Item
                              name="delivery_city"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                                {
                                  max: 50,
                                  message: "Maximum 50 characters are allowed",
                                },
                              ]}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : customerDetails?.delivery_city
                              }
                              className=""
                            >
                              <Input
                                placeholder={action === "view"?'':"City"}
                                disabled={checkedBox || action == "view"}
                                className="disabled-check"
                                style={{ textTransform: "capitalize" }}
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                        <div className="boxFormType">
                          <DisabledStyles>
                            <Form.Item
                              name="delivery_pincode"
                              rules={[
                                {
                                  required: !switchFetchOrdersfromERP,
                                  message: "This field is required",
                                },
                                // {
                                //   max: 10,
                                //   message: "Maximum 10 characters are allowed",
                                // },
                                { min: 6, message: "Minimum length: 6" },
                                { max: 6, message: "Maximum length: 6" },
                              ]}
                              initialValue={
                                action == "add"
                                  ? ""
                                  : customerDetails?.delivery_pincode
                              }
                              className=""
                            >
                              <Input
                                disabled={checkedBox || action == "view"}
                                className="disabled-check"
                                placeholder={action === "view"?'':"ZIP code"}
                              />
                            </Form.Item>
                          </DisabledStyles>
                        </div>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All Other information related to this customer</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                        <div className="boxFieldTitle">
                        <label>Reel Diameter</label>
                          <p>
                          An order can have multiple or single diameter for this customer
                          </p>
                        </div>
                    </Col>
                    <Col span={12}>
                      <div
                          className="boxFormType switchRadio"
                          style={{
                            justifyContent: "flex-end",
                            display: "flex",
                          }}
                        >
                          <Form.Item
                            name="diameter"
                            initialValue={
                              action == "add" ? "single" : customerDetails?.reel_diameter 
                            }
                            className=""
                          >
                            <Radio.Group
                              options={diameterData}
                              onChange={handleDiameterChange}
                              value={reelDiameter}
                              optionType="button"
                              buttonStyle="solid"
                              disabled={action == "view"}
                            />
                          </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Status</label>
                        <p>
                          The order for this customer will only be recorded if
                          it's enabled
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{
                          justifyContent: "flex-end",
                          display: "flex",
                        }}
                      >
                        <Form.Item
                          name="status"
                          initialValue={
                            action == "add" ? "active" : customerDetails.status
                          }
                          className=""
                        >
                          <Radio.Group
                            options={userStatusData}
                            onChange={handleStatusChange}
                            value={userStatus}
                            optionType="button"
                            buttonStyle="solid"
                            disabled={action == "view"}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Remarks <span>(Optional)</span>
                        </label>
                        <p>Extra information of this customer</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Form.Item
                            name="remarks"
                            rules={[
                              {
                                max: 70,
                                message:
                                  "Remarks cannot be longer than 70 characters",
                              },
                            ]}
                            initialValue={
                              action == "add" ? "" : customerDetails?.remarks
                            }
                            className=""
                          >
                            <TextArea
                              maxLength={100}
                              style={{ height: 90 }}
                              disabled={action == "view"}
                            />
                          </Form.Item>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>

      <ConfirmationModal
        visible={visible}
        icon={warning}
        cancelAction={modalCancel}
        confirmAction={modalConfirm}
      >
        <span>Are you sure?</span>
        <p>
          You have pending changes on this page, are you sure you want to leave?
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={viewDelete}
        icon={warning}
        cancelAction={modalCancelDelete}
        confirmAction={modalConfirmDelete}
        param={customerCode}
      >
        <span>Delete Customer?</span>
        <p>
          A customer deleted once cannot be recovered. Are you sure you want to
          proceed?
        </p>
      </ConfirmationModal>

      {/* {addToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setAddToaster}
          color={`${actionResponse.error ? "red" : "green"} toaster`}
          icon={actionResponse.error ? alertRed : alertGreen}
          msg={
            actionResponse.error
              ? actionResponse.msg
              : `A new customer ${actionResponse.code} is successfully added`
          }
        />
      )} */}

      {editToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setEditToaster}
          color={`${actionResponse.error ? "red" : "green"} toaster`}
          icon={actionResponse.error ? alertRed : alertGreen}
          msg={
            actionResponse.error
              ? actionResponse.msg
              : `Changes to customer ${actionResponse.code} are saved successfully`
          }
        />
      )}
      {deleteError && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={deleteMsg}
        />
      )}
    </RightLayoutContainer>
  ) : (
    <div></div>
  );
};

export default AddNewCustomer;
